<div class="main row" cdkDropListGroup>
  <div class=" sidebar left-view" [hidden]="!rightLeftPanel">
    <ze-object-list-main [viewComponent]="this" [active]="false" [listInteface]="actionListInterface"
      [showStep]="showSaveButton"></ze-object-list-main>
  </div>
  <div class="canvas">
    <ze-canvas2 [showSaveButton]="showSaveButton" [model]="currentStep" [ctvList]="ctvList"
      [ObjectList]="targetobjectListInterface" [ActionList]="actionListInterface" (canvasSaveAs)="saveAs($event)"
      (canvas)="updateCanvas($event)" (onDelete)="delete($event)" (modifyStep)="modifyStepEvent($event)"
      (hideCanvas)="hideStepfn($event)" (onWebPageSave)="getWebPages()" (onTargetObjectSave)="refreshWebPageObjects()"></ze-canvas2>
  </div>
  <div class="sidebar right-view" [hidden]="!rightLeftPanel">
    <mat-form-field class="page-selector" [floatLabel]="'never'">
      <mat-label>Select Page</mat-label>
      <mat-select #pn (selectionChange)="changePage(pn.value)">
        <mat-option *ngFor="let page of webpages" [value]="page._id" [style.color]="page.color">
          {{page.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ze-object-list-main [viewComponent]="this" [active]="false" [listInteface]="targetobjectListInterface"
      *ngIf="targetobjectListInterface.models!=undefined; else noData"></ze-object-list-main>
    <ng-template #noData>
      <h5 class="text">Please select a page with target objects </h5>
    </ng-template>
  </div>
</div>